import React from 'react';
import PropTypes from 'prop-types';
import { useAppContext } from 'context/AppContext';
import strings from 'localization/strings';
import { makeStyles } from 'styles/util';

import List from '@material-ui/core/List';
import ChatBubbleRoundedIcon from '@material-ui/icons/ChatBubbleRounded';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import Text from 'common/Text';
import MarginBox from 'common/MarginBox';
import ImageThumbnails from 'common/ImageThumbnails';
import ShortDateTime from 'common/ShortDateTime';

const useStyles = makeStyles(({ theme, colors }) => ({
    tenant: {
        color: `${colors.attentionBackground} !important`
    },
    owner: {
        color: `${colors.primaryColor} !important`
    },
    createdTime: {
        opacity: 0.6
    },
    companyIcon: {
        height: '1em'
    },
    contactDetailsIncluded: {
        color: colors.attention,
        marginRight: theme.spacing(1)
    }
}));

const MessageList = ({ messages }) => {
    const classes = useStyles();
    const { appContext } = useAppContext();

    return (
        <List>
            {
                messages.map(message => {
                    let icon;
                    let senderName;

                    if (message.adminName) {
                        senderName = `${message.adminName} (${strings.companyName})`;
                        icon = <img src={appContext.images.shortLogo} className={classes.companyIcon} />;
                    } else {
                        senderName = message.senderName;

                        const chatBubbleClassName = message.senderIsOwner
                            ? classes.owner
                            : classes.tenant;

                        icon = <ChatBubbleRoundedIcon className={chatBubbleClassName} />;
                    }

                    return (
                        <ListItem key={message.id} alignItems="flex-start">
                            <ListItemIcon>
                                {icon}
                            </ListItemIcon>
                            <ListItemText>
                                <Typography variant="caption" gutterBottom>
                                    {senderName} <span className={classes.createdTime}><ShortDateTime value={message.createdTime}/></span>
                                </Typography>
                                <Typography variant="body1">
                                    {
                                        message.contactDetailsIncluded && <WarningIcon className={classes.contactDetailsIncluded}/>
                                    }
                                    <Text html={message.body} />
                                    {
                                        message.images.length > 0 &&
                                        (
                                            <MarginBox top={2}>
                                                <ImageThumbnails images={message.images} />
                                            </MarginBox>
                                        )
                                    }
                                </Typography>
                            </ListItemText>
                        </ListItem>
                    );
                })
            }
        </List>
    );
};

MessageList.propTypes = {
    messages: PropTypes.array.isRequired
};

export default MessageList;
